export const privacySetting = {
    terms_conditions: 'ข้อกำหนดและเงื่อนไข',
    privacy_policy: 'คำชี้แจ้งส่วนบุคคล',
    marketing_message: 'การยินยอมเพื่อวัตถุประสงค์ทางการตลาด',
    marketing_consent: {
        marketing_message: 'ฉันสนใจและต้องการรับข้อมูลข่าวสารเกี่ยวกับสินค้า บริการ ของแถม ส่วนลด โปรโมชั่น และกิจกรรมต่างๆ ที่เกี่ยวข้องจาก ShopDD และ ผลิตภัณฑ์จากบริษัทในเครือ บริษัท บัซซี่บีส์ จำกัด กรุณาเลือกอย่าง 1 ช่องทาง',
        email: 'อีเมล์',
        sms: 'ข้อความสั้น (SMS)',
        update: 'บันทึก'
    },
    confirm_popup: {
        title: 'ยืนยัน?',
        msg: 'คุณจะพลาดโอกาสรับข้อมูลข่าวสารเกี่ยวกับสินค้า บริการ ของแถม ส่วนลด โปรโมชั่น และกิจกรรมต่างๆได้ ยังยืนยันใช่หรือไม่',
        btnOk: 'ตั้งค่าใหม่',
        btnCancel: 'ยกเลิก'
    },
    success: {
        title: 'ทำรายการสำเร็จ!',
        btn: 'ตกลง'
    }
}
